/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Col, Input, Modal, Row, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import BreakLine from "../../../component/Desktop/breakLine";
import GroupItem from "../../../component/Desktop/groupItem";
import Loading from "../../../component/Desktop/loading/loading";
import RowInput from "../../../component/Desktop/rowInput";
import TitlePage from "../../../component/Desktop/titlePage";
import {
  COMMON_CONSTANT,
  KEY,
  lang,
  STYLE,
} from "../../../constants/common.const";
import {
  checkErrorDuplicateFileName,
  handleCatchError,
  showMessage,
} from "../../../constants/utils";

import {
  CloseCircleOutlined,
  DeleteOutlined,
  SaveOutlined,
  ToTopOutlined,
  QuestionCircleOutlined
} from "@ant-design/icons";

import { ApiDisaster } from "../../../api/backend/disaster";
import classText from "../../../models/control/text";
import { getIconByFileType } from "../../../utils/helper";

let order = 1;
//Declare global variables
function AddDisasterCategory() {
  let { id } = useParams();
  const history = useHistory();
  let [showLoading, setShowLoading] = useState(false);
  // Loading
  let openLoadingSpinner = () => {
    setShowLoading(true);
  };

  let closeLoadingSpinner = () => {
    setShowLoading(false);
  };
  // Focus
  const fileEl = useRef(null);

  let [tblAttach, setTblAttach] = useState([]);
  let [txtNameDisasterCategory, settxtNameDisasterCategory] = useState(
    new classText()
  ); //Requireq

  //
  let [txtUser, setTxtUser] = useState(new classText());

  let txtNameDisasterCategoryEl = useRef(null);

  // Save Data
  const onSaveData = async () => {
    try {
      openLoadingSpinner();
      const dataPost = {
        name: txtNameDisasterCategory.value,
        attachments: tblAttach,
      };
      !id
        ? await ApiDisaster.addCategory(dataPost)
        : await ApiDisaster.updateCategory(dataPost, id);
      showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, () => {
        history.goBack();
      });
    } catch (error) {
      handleCatchError(error);
    } finally {
      closeLoadingSpinner();
    }
  };
  // Popup common
  const showConfirmMessage = (
    msg,
    callbackOK,
    callbackCancel,
    typeInfo = false
  ) => {
    let ok, cancel;
    let callBackDefault = () => {
      Modal.destroyAll();
    };

    // Callback OK exist
    if (callbackOK) {
      ok = () => {
        callbackOK();
        callBackDefault();
      };
    }
    // Callback Cancel exist
    if (callbackCancel) {
      cancel = () => {
        callbackCancel();
        callBackDefault();
      };
    }

    Modal.confirm({
      centered: true,
      icon: <QuestionCircleOutlined />,
      title: lang.CONFIRM,
      content: msg,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onCancel: cancel || callBackDefault,
      onOk: ok || callBackDefault,
    });
  };

  //Save function: 1
  function confirmSaveData() {
    if (!validateSave()) {
      return;
    }
    showConfirmMessage(COMMON_CONSTANT.BOM_C008, onSaveData);
  }

  // Validate data

  function validateSave() {
    let flagErr = false,
      elmFocus;

    txtNameDisasterCategory = {
      ...txtNameDisasterCategory,
      value: txtNameDisasterCategory.value.trim(),
      error: false,
    };

    if (txtNameDisasterCategory.value.length === 0) {
      flagErr = true;
      // Border red
      txtNameDisasterCategory = { ...txtNameDisasterCategory, error: true };
      elmFocus = txtNameDisasterCategoryEl;
    }

    // Focus item error
    elmFocus && elmFocus.current && elmFocus.current.focus();

    // Update state
    settxtNameDisasterCategory(txtNameDisasterCategory);

    setTxtUser(txtUser);

    return !flagErr;
  }

  // Get Detail
  const getDetailCategory = async () => {
    try {
      setShowLoading(true);
      const res = await ApiDisaster.getDetailCategory(id);
      const data = res.data;
      settxtNameDisasterCategory({
        ...txtNameDisasterCategory,
        value: data.name,
      });
      setTblAttach([...data.attachments]);
    } catch (error) {
      handleCatchError(error);
    } finally {
      setShowLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      getDetailCategory();
    }
  }, [id]);
  // Upload file
  async function readAttachFileUrl(e) {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    if (file.name) {
      const isErrorNamefile = checkErrorDuplicateFileName(
        file.name,
        tblAttach,
        "attachFileName"
      );
      if (isErrorNamefile) {
        return;
      }
    }
    const formData = new FormData();
    const body = {
      attachFileName: file.name,
      type: 3,
    };
    formData.append("data", JSON.stringify(body));
    formData.append("file", file);
    const fileRes = await ApiDisaster.uploadFile(formData);
    const url = fileRes.data.url;
    const newListAttach = [...tblAttach];
    newListAttach.push({
      itemOrder: order++,
      attachFileUrl: url,
      attachFileName: file.name,
    });
    setTblAttach(newListAttach);

    fileEl.current.value = null;
  }

  return (
    <div className="des-content">
      <Loading show={showLoading}></Loading>
      <TitlePage
        name={id ? lang.DISASTER_CATEGORY_EDIT : lang.DISASTER_CATEGORY_ADD}
      />

      <GroupItem center>
        <div className="title-page d-block center mt0 mb0">
          <h1 className="bold white-space">
            {id ? lang.DISASTER_CATEGORY_EDIT : lang.DISASTER_CATEGORY_ADD}
          </h1>
        </div>
        <div className="mt15"></div>
        <BreakLine />
        <RowInput name={lang.DISASTER_CATEGORY} required box>
          <Input
            ref={txtNameDisasterCategoryEl}
            className={txtNameDisasterCategory.error ? STYLE.BORDER_RED : ""}
            value={txtNameDisasterCategory.value}
            onChange={(v) => {
              settxtNameDisasterCategory({
                ...txtNameDisasterCategory,
                value: v.target.value,
              });
            }}
          />
        </RowInput>
        <BreakLine />
        <RowInput name={lang.ATTACH} box>
          <>
            <input
              type="file"
              className="d-none"
              // accept=".xls,.xlsx"
              ref={fileEl}
              onChange={readAttachFileUrl}
            />
            <Button
              type="link"
              onClick={() => fileEl.current.click()}
              className="buttonPC button--outline --todo-- wAuto"
              style={{
                marginBottom: 10,
              }}
            >
              <ToTopOutlined />
              {lang.ATTACH_FILE}
            </Button>

            {tblAttach.length > 0 &&
              tblAttach.map((item, index) => {
                let urlFile = item.attachFileUrl;
                return (
                  <Row
                    className="mb10"
                    key={index}
                    style={{ alignItems: "center" }}
                  >
                    <Col span={2}>
                      <Button
                        onClick={() => {
                          let list = [...tblAttach].filter(
                            (x) => x["itemOrder"] !== item["itemOrder"]
                          );
                          setTblAttach(list);
                        }}
                        className="btn-deletefile mr8"
                        style={{
                          background: "#f7f9fc",
                          minWidth: "unset",
                          height: 30,
                        }}
                        icon={<DeleteOutlined />}
                      />
                    </Col>
                    <Col
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {getIconByFileType(item.attachFileName)}
                      <a target="_blank" href={urlFile}>
                        {item.attachFileName}{" "}
                      </a>
                    </Col>
                  </Row>
                );
              })}
          </>
        </RowInput>
        <BreakLine />
        {/* Button footer */}
        <Row justify="end" className="mt10 mb10">
          <Button
            className="buttonPC button--info wAuto ml15"
            onClick={() => {
              confirmSaveData();
            }}
          >
            <SaveOutlined />
            {COMMON_CONSTANT.SAVE}
          </Button>
          <Button
            onClick={() => history.goBack()}
            className="buttonPC button--outline --todo-- wAuto ml15"
          >
            <CloseCircleOutlined />
            {lang.CANCEL}
          </Button>
        </Row>
      </GroupItem>
    </div>
  );
}

export default AddDisasterCategory;
